export const COUPON_DETAIL = "COUPON_DETAIL"
export const COUPON_LOADING = "COUPON_LOADING"
export const COUPON_USED = "COUPON_USED"